import { isXSell } from "@tvg/sh-utils/mobileUtils";
import { ENV_KEYS } from "../../constants";
import { getXsellKeys } from "../../utils";

export const EXPERIMENT_KEY = "mcn-826-urp-pp-on-x-sell";
export const DEPLOYMENT_KEY = isXSell() ? getXsellKeys() : ENV_KEYS.fdr_fe.web;
